import loadComponents from 'gia/loadComponents';
import config from 'gia/config';


//import Menu from './menu'
// import Animation from './animation'
// import Projects from './projects'
import Newsletter from './newsletter'
import Cards from './cards'
import Slider from './slider'
import gsap from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin.js';
gsap.registerPlugin(ScrollToPlugin);



import lazySizes from 'lazysizes';

//import owd from '../owd/owd';

// import CustomCursor from './custom-cursor';
// import CustomHover from './custom-hover';
// import '../components/cursor-mode';
// import '../components/cursor-hover';
// import '../components/cursor-theme';

class App {

  constructor($) {
    this.create()
  }

  create() {

      lazySizes.init()
      config.set('log', false); // disables unnecessary console.log calls

      // const app = new owd.App();
      // app.use('customCursor', CustomCursor);
      // app.use('customHover', CustomHover);
      // app.run();

      const components = {

        // Animation: Animation,
        // Projects: Projects,
        // Services: Services,
        Cards: Cards,
        Slider: Slider,
        Newsletter: Newsletter
        
      }

      loadComponents(components)

      //$('body').addClass('loaded')

      
      $('.item').on('click', (e)=>{

        e.preventDefault()

        if (!$(e.currentTarget).hasClass('is-active')){
          $('.item.is-active').removeClass('is-active')
          $(e.currentTarget).addClass('is-active')
        }

        else {
          $('.item.is-active').removeClass('is-active')
        }

        
      })
     
     

  }


}

module.exports = App
